<template>
	<div>
		<div class="titleIcon">
			<div class="inlin">
				<i :class="`iconfont ${icon} tableIcon`"></i>
				<span class="fz16">{{title}}</span>
			</div>
		</div>
		<div class="portraitLine disflex" ref="breadcrumb">
			<div v-if="reportList&&reportList.length>0" ref="nationwide">
				<div class="echarts">
					<div :id="echarts" class="barchartsHeight" ref="echarts"></div>
				</div>
			</div>
			<div v-else class="echartslineNull">
				<div class="icon">
					<svg-icon class="fz18 marr4" icon-class='icon-default-Nodata'></svg-icon>
				</div>
				<div class="text">暂无数据</div>
			</div>
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts'
	export default {
		props: ['name', 'colorList', 'icon', 'title', 'reportList', 'chartsType'],
		data() {
			return {
				myChart: null,
				height: 25,
				barMaxWidth: 7,
				num: 0,
				data: [],
				value: [],
				legend: []
			}
		},
		computed: {
			...Vuex.mapState('supervisor', ['breadcrumbList', 'GetReportListArr']),
			...Vuex.mapState('breadcrumb', ['reportScreening','skinPeeler']),
			...Vuex.mapState('visualization', ['trigger']),
			echarts() {
				return 'echarts' + this.getCode();
			}
		},
		watch: {
			reportList(old, news) {
				let _this = this;
				if (this.reportList) {
					this.trigger.hospital = false;
					this.$nextTick(() => {
						_this.update();
						_this.getEcharts();
					})
				}
			},
			skinPeeler: {
			  handler(newValue, oldValue) {
				   let _this = this;
					_this.update();
					_this.getEcharts();
			  },
			  deep: true
			}
		},
		// updated() {
		// 	let _this = this;
		// 	if (this.trigger.hospital) {
		// 		this.trigger.hospital = false;
		// 		this.$nextTick(() => {
		// 			_this.update();
		// 			_this.getEcharts();
		// 		})
		// 	}
		// },
		mounted() {
			//左侧导航收起时右侧图联动
			let _this = this;
			// this.$nextTick(() => {
			// 	_this.update();
			// 	_this.getEcharts();
			// })
			this.erd.listenTo(document.getElementsByClassName("el-main"), function(element) {
				if (_this.myChart) {
					let dom = document.getElementById(_this.echarts);
					if (dom) {
						dom.style.width = _this.$refs.nationwide.offsetWidth - 40 + "px";
						_this.myChart.resize();
						// _this.update();
						_this.getEcharts();
					}
				}
			})
		},

		methods: {
			...Vuex.mapMutations('breadcrumb', ['setTootipType', 'clearRow']),
			...Vuex.mapMutations('supervisor', ['currentChangesSecond', 'setBreadcrumbList']),
			update() {
				let _this = this;
				this.reportList.forEach(element => {
					_this.legend.push(element.Name)
					element.newScoreHistory = element.ScoreHistory.map(function(res){
						return res.RankStr
					})
				})
				_this.data = [];
				this.reportList[0].ScoreHistory.forEach(res => {
					_this.data.push(res.Month)
				})
				_this.value = this.reportList.map(function(item) {
					return {
						name: item.Name,
						type: 'line',
						data: item.newScoreHistory,
						symbol: 'circle',  //设定为实心点 
						symbolSize: 4,
					}
				})
			},
			getEcharts() {
				let _this = this;
				let dom = document.getElementById(_this.echarts);
				this.height = 14.5;
				this.barMaxWidth = 7;
				if (dom) {
					dom.style.width = this.$refs.breadcrumb.offsetWidth + "px";
					dom.style.height = this.$refs.breadcrumb.offsetHeight - 15 + "px";
					this.myChart = echarts.init(dom);
				}
				let changeColor = this.skinPeeler.status?'#ffffff':'#333333';
				let app = {};
				let option = null;
				option = {
					color: _this.colorList,
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'none'
						},
					},
					legend: {
						left: this.$refs.breadcrumb.offsetWidth-230,
						top:10,
						data: _this.legend,
						itemWidth: 12,
						itemHeight: 12,
						icon: 'roundRect',
						textStyle: {
							color: changeColor,
							fontSize: "12",
							width: 30
						 }
					},
					grid: {
						left: 20,
						right: 20,
						bottom: 0,
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: _this.data,
						boundaryGap: false,
						triggerEvent: true,
						axisTick: {
							show: false,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#3D4049'
							}
						},
						axisLabel: {
							show: true,
							interval: 0,
							rotate: 30,
							textStyle: {
								color: changeColor,
								fontSize: 12
							},
							padding: [20, 0, 0, 0]
						},
						splitLine: {
							show: false
						}
					},
					yAxis: {
						type: 'value',
						axisTick: {
							show: false
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#3D4049'
							}
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: changeColor,
								fontSize: 12
							}
						},
						splitLine: {
							show: false
						}
					},
					series:_this.value
				};
				if (option && typeof option === "object" && this.myChart) {
					this.myChart.clear()
					this.myChart.setOption(option, true);
					this.myChart.off('click'); //清除联系点击
					this.myChart.on('click', (params) => {});
					this.myChart.resize(); //区域更新
					window.addEventListener("resize", () => {
						this.myChart.resize();
					});
				}
			}
		}

	}
</script>
<style type="text/css" scoped="scoped">
	.bigScreen .barSubpageHeight {
		height: 330px;
	}

	.bigScreen .titleIcon {
		top: 16px;
		left: 20px;
	}
</style>
